/* istanbul ignore file */
export const AUTH_BASE_PATH = '/auth';

export const LOGIN_PATH = '/login';
export const LOGIN_CALLBACK_PATH = '/loginCallback';

export const LOGOUT_PATH = '/logout';
export const LOGOUT_CALLBACK_PATH = '/logoutCallback';

export const REGISTER_PATH = '/register';
export const REGISTER_CALLBACK_PATH = '/registerCallback';

export const PASSWORD_RESET_PATH = '/passwordReset';
export const PASSWORD_RESET_PATH_CALLBACK_PATH = '/passwordResetCallback';

export const REFRESH_PATH = '/refresh';

export const EXCHANGE_PATH = '/exchange';
export const EXCHANGE_CALLBACK_PATH = '/exchangeCallback';

export const IDENTITY_WEBAPP_BASE_PATH = '/user';
export const IDENTITY_WEBAPP_REGISTER_PATH = `${IDENTITY_WEBAPP_BASE_PATH}/register`;
export const IDENTITY_WEBAPP_PASSWORD_RESET_PATH = `${IDENTITY_WEBAPP_BASE_PATH}/password-reset`;

export const APP_LOGIN_PATH = '/app/login';
export const APP_REFRESH_PATH = '/app/refresh';
export const APP_LOGOUT_PATH = '/app/logout';
